import { Courses } from "../courses"

export const OnboardingLearnings = ({pageSwap, courseToUpdate, setCourseToUpdate, AiStarted }) => {
    return(
        <Courses
            titleScreen = "Onboarding learnings"
            CustomerStage = {2}
            pageSwap={pageSwap}
            courseToUpdate={courseToUpdate}
            setCourseToUpdate={setCourseToUpdate}
            AiStarted={AiStarted}
            
        />
    )
}